import { render, staticRenderFns } from "./SettingsStaff.vue?vue&type=template&id=79e3c749&scoped=true&"
import script from "./SettingsStaff.vue?vue&type=script&lang=js&"
export * from "./SettingsStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e3c749",
  null
  
)

export default component.exports